unique.offer = {
    init: function () {
        unique.offer.event = unique.utilities.registerEvents( 'productadd productadded', 'offer' );
        unique.offer.bindFormValidation();
        unique.offer.bindEvents();
        unique.offer.bindFormAutoPost();

    },
    updateQuantityInfo: function ( jsonOffer ) {
        var _updateOfferProductQuantity = function () {
                var jOfferQuantity = jQuery( '.js-unique-offer-product-quantity' );
                if ( jOfferQuantity.length > 0 ) {
                    jOfferQuantity.html( jsonOffer.productQuantity );
                }
            },
            _updateProductIsInCurrentOfferIndicator = function () {
                var jProductItem = jQuery( '.js-e-product, .js-e-productlist-item, .js-unique-offer-product-search-item' ).filter( '[data-product-id="' + jsonOffer.cartCmdResponse.product.id + '"]' );
                if ( jProductItem.length > 0 ) {
                    jProductItem.find( '.js-unique-product-is-in-current-offer-indicator' ).toggleClass( 'is-hidden', jsonOffer.cartCmdResponse.product.isInCurrentOffer === false );
                }
            };
        _updateOfferProductQuantity();
        _updateProductIsInCurrentOfferIndicator();
    },
    updatePriceInfo: function ( jsonOffer ) {
        console.log( jsonOffer.cartCmdResponse.orderLine.priceSubtotal, jsonOffer );
    },
    updateOfferLines: function ( jsonOfferLines ) {
        var jOfferLines = jQuery( '.js-unique-offer-lines' );
        if ( jOfferLines.length === 1 ) {
            jQuery.each( jsonOfferLines, function ( strOfferLineId, strOfferLineHtml ) {
                var jOfferLine = jQuery( '#js-unique-offer-line-' + strOfferLineId );
                if ( jOfferLine.length === 1 ) {
                    jOfferLine.replaceWith( strOfferLineHtml );
                }
                else {
                    jOfferLines.prepend( strOfferLineHtml );
                }
            } );
        }
    },
    showProductAddedToOfferSuccessIndicator: function ( jForms ) {
        jForms.each( function ( intIndex, domForm ) {
            var jButton = jQuery( domForm ).find( '.js-unique-add-to-offer-btn' );
            jButton.addClass( 'is-added' );
            setTimeout( function () {
                jButton.removeClass( 'is-added' );
            }, e4.settings.ecom.cart.msgHideDelay / 2 );
        } );
    },
    bindEvents: function () {
        var arrOfferActionsToSetFormFieldValuesOnModalShow = [
                'edit-offer-line',
                'group-offer-lines-by-vendor',
                'copy-offer',
                'copy-offer-line',
                'delete-offer-line',
                'delete-all-lines-in-offer',
                'delete-offer',
                'download-offer-as-pdf',
            ],
            _getForm = function ( objEvent, strOfferAction ) {
                return jQuery( objEvent.target ).find( '.js-unique-' + strOfferAction + '-form' ).get( 0 );
            },
            _getFieldNamesAndValues = function ( objEvent ) {
                return jQuery( objEvent.relatedTarget ).closest( '.dropdown' ).data( 'form-field-names-with-values' );
            },
            _setFormFieldValuesFromJson = function ( domForm, jsonFieldNamesAndValues ) {
                var jForm = jQuery( domForm );
                jQuery.each( jsonFieldNamesAndValues, function ( strFieldName, strFieldValue ) {
                    jForm.find( '[name="' + strFieldName + '"]' ).val( strFieldValue );
                    console.log( strFieldName, strFieldValue, jForm.find( '[name="' + strFieldName + '"]' ).val() );
                } );
            },
            _getSortField = function ( domNode ) {
                return jQuery( domNode ).closest( '.js-unique-offer-line' ).find( '.js-unique-offer-lines-sort-input' ).get( 0 );
            };
        jQuery.each( arrOfferActionsToSetFormFieldValuesOnModalShow, function ( intIndex, strOfferAction ) {
            jQuery( '#js-unique-' + strOfferAction + '-modal' ).on( 'show.bs.modal', function ( objEvent ) {
                _setFormFieldValuesFromJson( _getForm( objEvent, strOfferAction ), _getFieldNamesAndValues( objEvent ) );
            } ).on( 'hidden.bs.modal', function ( objEvent ) {
                _getForm( objEvent, strOfferAction ).reset();
            } );
        } );
        jQuery( '.js-unique-offer-lines' ).on( 'input', 'input,textarea', e4.util.debounce( function ( objEvent ) {
            console.log( 'on input debounce', objEvent.target.tagName );
            unique.offer.editLine( objEvent.target );
        }, e4.settings.debounceDelay.input * 2 ) ).on( 'change', 'select', function ( objEvent ) {
            unique.offer.editLine( objEvent.target );
        } ).on( 'click', '.js-unique-offer-line-move-up-btn', function ( objEvent ) {
            console.log( 'sort move up', _getSortField( objEvent.target ) );
            unique.offer.sortLine( _getSortField( objEvent.target ), e4.settings.offer.sortDirection.up );
        } ).on( 'click', '.js-unique-offer-line-move-down-btn', function ( objEvent ) {
            console.log( 'sort move down', _getSortField( objEvent.target ) );
            unique.offer.sortLine( _getSortField( objEvent.target ), e4.settings.offer.sortDirection.down );
        } ).tooltip( {
            selector: 'input[data-toggle="tooltip"]',
            html: true,
            placement: 'right',
            trigger: 'focus',
            title: function () {
                return jQuery( '#tooltip_content_for_' + this.id ).html();
            }
        } );
        jQuery( document ).on( unique.offer.event.productadded, function ( objEvent, jsonOffer ) {
            var jForms = jQuery( '.js-unique-add-product-to-offer-form' ).filter( '[data-product-id="' + jsonOffer.cartCmdResponse.product.id + '"]' );
            unique.offer.showProductAddedToOfferSuccessIndicator( jForms );
        } );
    },
    bindFormValidation: function () {
        e4.require.js( e4.settings.require.jQueryValidate, function () {
            var objOfferActionsAndSubmitHandlers = {
                'add-offer': unique.offer.add,
                'edit-offer': unique.offer.edit,
                'group-offer-lines-by-vendor': unique.offer.groupLinesByVendor,
                'sort-offer-lines-by-name': unique.offer.sortLinesByName,
                'copy-offer-line': unique.offer.copyLine,
                'copy-offer': unique.offer.copy,
                'delete-offer-line': unique.offer.deleteLine,
                'delete-all-lines-in-offer': unique.offer.deleteAllLines,
                'delete-offer': unique.offer.delete,
                'download-offer-as-pdf': unique.offer.downloadAsPdf,
            };
            jQuery.each( objOfferActionsAndSubmitHandlers, function ( strOfferAction, fnSubmitHandler ) {
                //console.log( strOfferAction, jQuery( '.js-unique-' + strOfferAction + '-form' ) );
                jQuery( '.js-unique-' + strOfferAction + '-form' ).validate( {
                    submitHandler: function ( domForm ) {
                        console.log( strOfferAction, 'submit handler call' );
                        fnSubmitHandler.call( unique.offer, domForm );
                    }
                } );
            } );
            jQuery( document ).on( 'submit', '.js-unique-add-product-to-offer-form', function ( objEvent ) {
                objEvent.preventDefault();
                var jForm = jQuery( objEvent.target ),
                    objValidator = jForm.validate( {
                        submitHandler: function ( domForm ) {
                            unique.offer.addProductByForm( domForm );
                        }
                    } );
                if ( jForm.valid() === true ) {
                    objValidator.settings.submitHandler.call( objValidator, objValidator.currentForm );
                }
            } );
        } );
    },
    bindFormAutoPost: function () {
        var arrOfferActionsToAutoPost = [
            'group-offer-lines-by-vendor',
            'sort-offer-lines-by-name',
            'copy-offer-line',
            'delete-offer-line',
        ];
        jQuery.each( arrOfferActionsToAutoPost, function ( intIndex, strOfferAction ) {
            jQuery( '#js-unique-' + strOfferAction + '-modal' ).on( 'show.bs.modal', function ( objEvent ) {
                unique.utilities.loader.show( objEvent.target );
            } ).on( 'shown.bs.modal', function ( objEvent ) {
                setTimeout( function () {
                    jQuery( objEvent.target ).find( '.js-unique-' + strOfferAction + '-form' ).triggerHandler( 'submit' );
                }, e4.settings.offer.formAutoPostDelay );
            } );
        } );
    },
    ajax: function ( objAjaxSettings ) {
        var _objAjaxSettings = jQuery.extend( true, {
                url: e4.settings.offer.url,
                method: 'POST',
                data: {
                    Redirect: false
                },
            }, objAjaxSettings
        );
        console.log( 'offer.ajax', _objAjaxSettings );
        return unique.utilities.ajax( _objAjaxSettings );
    },
    setCurrentById: function ( strCartId ) {
        return unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.set,
                CartId: strCartId,
            }
        } );
    },
    setDetails: function ( domForm ) {
        var objAjaxSettingsData = jQuery.extend( {
            EcomOrderCustomerNumber: '',
            EcomOrderCustomerCompany: '',
            EcomOrderCustomerName: '',
            EcomOrderCustomerAddress: '',
            EcomOrderCustomerAddress2: '',
            EcomOrderCustomerZip: '',
            EcomOrderCustomerRegion: '',
            EcomOrderCustomerCity: '',
            EcomOrderCustomerCountry: '',
            EcomOrderCustomerCountryCode: '',
            EcomOrderCustomerEmail: '',
            EcomOrderCustomerFax: '',
            EcomOrderCustomerPhone: '',
        }, unique.utilities.serializeFormToObject( domForm ) );
        objAjaxSettingsData.CartCmd = e4.settings.offer.cartCmd.editCart;
        return unique.offer.ajax( {
            data: objAjaxSettingsData
        } );
    },
    add: function ( domForm ) {
        unique.utilities.loader.show( domForm );
        var objFormData = unique.utilities.serializeFormToObject( domForm );
        return jQuery.when( unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.add,
                CartName: objFormData.CartName,
                CartUserId: objFormData.CartUserId
            }
        } ) ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                console.log( 'cart created. setting current cart to id: ' + jsonOffer.cartCmdResponse.cart.id );
                return unique.offer.setCurrentById( jsonOffer.cartCmdResponse.cart.id );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Add offer failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                console.log( 'current cart is id: ' + jsonOffer.cartCmdResponse.cart.id, 'update cart with ', objFormData );
                return unique.offer.setDetails( domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Add offer failed. Could not set current offer. cmdResponse.success not true.', jsonOffer );
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Add offer failed. Could not set details on offer. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    edit: function ( domForm ) {
        unique.utilities.loader.show( domForm );
        var _setName = function ( domForm ) {
            var objFormData = unique.utilities.serializeFormToObject( domForm );
            return unique.offer.ajax( {
                data: {
                    CartCmd: e4.settings.offer.cartCmd.setName,
                    CartId: objFormData.CartId,
                    CartName: objFormData.CartName,
                }
            } );
        };
        return jQuery.when( _setName( domForm ) ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                return unique.offer.setDetails( domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Edit offer failed. Could not set offer name. cmdResponse.success not true.', jsonOffer );
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
                //console.log( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Edit offer failed. Could not set details on offer. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
            //console.log( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    copy: function ( domForm ) {
        unique.utilities.loader.show( domForm );
        var objFormData = unique.utilities.serializeFormToObject( domForm ),
            objAjaxSettingsData = {
                CartCmd: e4.settings.offer.cartCmd.copy,
                CartId: objFormData.CartId,
            };
        if ( objFormData.CartName !== '' ) {
            objAjaxSettingsData.CartName = objFormData.CartName;
        }
        if ( objFormData.CartUserId !== '' ) {
            objAjaxSettingsData.CartUserId = objFormData.CartUserId;
        }
        return jQuery.when( unique.offer.ajax( {
            data: objAjaxSettingsData
        } ) ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                return unique.offer.setCurrentById( jsonOffer.cartCmdResponse.cart.id );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Copy offer failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                return unique.offer.setDetails( domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Copy offer failed. Could not set current offer. cmdResponse.success not true.', jsonOffer );
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Copy offer failed. Could not set details on offer. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    deleteAllLines: function ( domForm ) {
        unique.utilities.loader.show( domForm );
        var objFormData = unique.utilities.serializeFormToObject( domForm );
        return jQuery.when( unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.deleteAllLines,
                CartId: objFormData.CartId,
            }
        } ) ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                return unique.offer.setCurrentById( jsonOffer.cartCmdResponse.cart.id );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Delete all lines failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                jQuery( '.js-unique-offer-lines' ).empty();
                unique.offer.updateQuantityInfo( jsonOffer );
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Delete all lines failed. Could not set current offer. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    delete: function ( domForm ) {
        unique.utilities.loader.show( domForm );
        var objFormData = unique.utilities.serializeFormToObject( domForm );
        return unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.delete,
                CartId: objFormData.CartId,
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                if ( jsonOffer.cartCmdResponse.cart.id === jsonOffer.id ) {
                    console.log( 'updateQuantityInfo', jsonOffer.id );
                    unique.offer.updateQuantityInfo( jsonOffer );
                }
                if ( jQuery( '.js-unique-offers' ).length === 1 ) {
                    var jOffer = jQuery( '#js-unique-offer-' + jsonOffer.cartCmdResponse.cart.id );
                    console.log( 'data', jQuery( domForm ).data() );
                    jQuery( domForm ).removeData( 'done-url' ).removeAttr( 'data-done-url' );
                    console.log( 'data', jQuery( domForm ).data() );
                    jOffer.remove();
                }
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Delete offer failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    downloadAsPdf: function ( domForm ) {
        var jForm = jQuery( domForm ),
            strPdfUrl = jForm.data( 'done-url' ),
            strPdfLayout = jForm.find( 'input[name="' + e4.settings.offer.pdfLayoutParamName + '"]' ).filter( ':checked' ).val();
        if ( strPdfUrl !== undefined && strPdfLayout !== undefined ) {
            strPdfUrl = unique.utilities.appendParameterToUrl( strPdfUrl, e4.settings.offer.pdfLayoutParamName, strPdfLayout );
            if ( strPdfUrl !== null ) {
                unique.utilities.modal.hide( domForm );
                window.open( strPdfUrl );
            }
        }
    },
    addProductByForm: function ( domForm ) {
        unique.utilities.loader.show( domForm );
        var objFormData = unique.utilities.serializeFormToObject( domForm );
        unique.utilities.disableAllSubmitButtonsInForm( domForm );
        return unique.offer.addProductById( objFormData ).always( function () {
            unique.utilities.enableAllSubmitButtonsInForm( domForm );
        } );
    },
    addMultipleProductsByForm: function ( arrForms ) {
        console.log( 'Adding multi to cart', arrForms )
        if ( arrForms !== undefined ) {
            var domAddMultipleProductsForm = jQuery( '.js-unique-add-multiple-products-to-offer-form' ).get( 0 ),
                _addProductByFormArrayIndex = function ( intIndex ) {
                    intIndex = intIndex || 0;
                    if ( arrForms.length > intIndex ) {
                        unique.offer.addProductByForm( arrForms[ intIndex ] ).always( function () {
                            _addProductByFormArrayIndex( intIndex + 1 );
                        } );
                    }
                    else {
                        unique.utilities.callback.done( null, null, null, domAddMultipleProductsForm );
                        console.info( 'Done adding multi to cart' )
                    }
                };
            unique.utilities.loader.show( domAddMultipleProductsForm );
            unique.utilities.modal.show( domAddMultipleProductsForm );
            _addProductByFormArrayIndex( 0 );
        }

    },
    addProductById: function ( objProductData ) {
        var objAjaxSettingsData = jQuery.extend( {
                CartCmd: e4.settings.offer.cartCmd.addProduct,
                OrderContext: '',
                ProductId: '',
                Quantity: 1,
            }, objProductData ),
            jDocument = jQuery( document );
        jDocument.trigger( unique.offer.event.productadd, objAjaxSettingsData );
        console.log( 'offer.addProductById', objAjaxSettingsData );
        return jQuery.when( unique.offer.ajax( {
            data: objAjaxSettingsData
        } ) ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                jDocument.trigger( unique.offer.event.productadded, jsonOffer );
                unique.offer.updateQuantityInfo( jsonOffer );
                unique.offer.updateOfferLines( jsonOffer.cartCmdResponse.product.offerLines );
                return jQuery.Deferred().resolve( jsonOffer, strTextStatus, jqXhr );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Add product to offer failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            console.log( jqXhr, strTextStatus, objErrorThrown, objAjaxSettingsData );
        } );
    },
    copyLine: function ( domForm ) {
        var objFormData = unique.utilities.serializeFormToObject( domForm );
        return unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.copyLine,
                key: objFormData.OrderLineId,
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                unique.offer.updateQuantityInfo( jsonOffer );
                jQuery( '#js-unique-offer-line-' + objFormData.OrderLineId ).after( jsonOffer.cartCmdResponse.orderLine.asHtml );
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Copy offer line failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    groupLinesByVendor: function ( domForm ) {
        return unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.groupLinesByVendor,
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Group offer lines failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    sortLinesByName: function ( domForm ) {
        return unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.sortLinesByName,
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Sort offer lines failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    editLine: function ( domInput ) {
        var jInput = jQuery( domInput ),
            strInputName = jInput.attr( 'name' ),
            objAjaxSettingsData = {
                cartcmd: e4.settings.offer.cartCmd.updateLine,
                key: jInput.closest( '.js-unique-offer-line' ).data( 'offer-line-id' )
            };
        objAjaxSettingsData[ strInputName ] = jInput.val();
        return unique.offer.ajax( {
            data: objAjaxSettingsData
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                console.info( 'editLine success' );
                unique.offer.updateQuantityInfo( jsonOffer );
                return jQuery.Deferred().resolve( jsonOffer, strTextStatus, jqXhr );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Edit offer line failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            console.error( strTextStatus, objErrorThrown );
        } );
    },
    deleteLine: function ( domForm ) {
        // Mangler test
        var objFormData = unique.utilities.serializeFormToObject( domForm );
        return unique.offer.ajax( {
            data: {
                CartCmd: e4.settings.offer.cartCmd.deleteLine,
                key: objFormData.OrderLineId,
            }
        } ).then( function ( jsonOffer, strTextStatus, jqXhr ) {
            if ( jsonOffer.cartCmdResponse.success === true ) {
                console.log( jsonOffer, strTextStatus, jqXhr, domForm );
                var jOfferLine = jQuery( '#js-unique-offer-line-' + jsonOffer.cartCmdResponse.orderLine.id );
                console.log( '#js-unique-offer-line-' + jsonOffer.cartCmdResponse.orderLine.id, jOfferLine );
                jOfferLine.remove();
                unique.offer.updateQuantityInfo( jsonOffer );
                unique.utilities.callback.done( jsonOffer, strTextStatus, jqXhr, domForm );
            }
            else {
                return jQuery.Deferred().reject( jqXhr, 'Delete offer line failed. cmdResponse.success not true.', jsonOffer );
            }
        } ).fail( function ( jqXhr, strTextStatus, objErrorThrown ) {
            console.log( jqXhr, strTextStatus, objErrorThrown, domForm );
            unique.utilities.callback.fail( jqXhr, strTextStatus, objErrorThrown, domForm );
        } );
    },
    sortLine: function ( domInput, strSortDirection ) {
        var jInput = jQuery( domInput ),
            jOfferLine = jInput.closest( '.js-unique-offer-line' ),
            intInputValue = parseInt( jInput.val() ),
            intInputValueNew = intInputValue;
        if ( strSortDirection === e4.settings.offer.sortDirection.up ) {
            intInputValueNew = intInputValue - 1;
        }
        else if ( strSortDirection === e4.settings.offer.sortDirection.down ) {
            intInputValueNew = intInputValue + 1;
        }
        if ( isNaN( intInputValue ) === false && intInputValueNew !== intInputValue ) {
            jQuery( domInput ).val( intInputValueNew );
            return unique.offer.editLine( domInput ).done( function ( jsonOffer, strTextStatus, jqXhr ) {
                console.log( 'sort line unique.offer.editLine done', jsonOffer );
                if ( strSortDirection === e4.settings.offer.sortDirection.up ) {
                    jOfferLine.insertBefore( jOfferLine.prev() );
                }
                else if ( strSortDirection === e4.settings.offer.sortDirection.down ) {
                    jOfferLine.insertAfter( jOfferLine.next() );
                }
            } );
        }
    },
};
